import(/* webpackMode: "eager" */ "/var/www/html/prod/src/components/intermediate/initiative-swiper-listing.tsx")